import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import VisualizerCore from "@/components/VisualizerCore";

export default function SalesVisualizer() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session");
  const preloadedRoomUrl = searchParams.get("room");

  const visualizerApi = useMemo(
    () => ({
      getRetailer: () => api.get("/sales/retailer").then((r) => r.data),
      getProducts: (category) => api.get("/sales/products", { params: { category } }).then((r) => r.data),
      uploadFile: (file) => {
        const fd = new FormData();
        fd.append("file", file);
        return api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
      },
      submitRender: (payload) => {
        if (sessionId) {
          return api.post(`/sales/queue/${sessionId}/render`, payload).then((r) => r.data);
        }
        return api.post("/sales/history", payload).then((r) => r.data);
      },
      getRenderStatus: (id) => api.get(`/history/${id}`).then((r) => r.data),
      enhanceRoom: (roomImageUrl) =>
        api.post("/sales/enhance-room", { room_image_url: roomImageUrl }).then((r) => r.data),
    }),
    [sessionId]
  );

  return (
    <VisualizerCore
      api={visualizerApi}
      notFoundMessage="Your account isn't linked to an active store. Contact your manager."
      preloadedRoomUrl={preloadedRoomUrl || undefined}
    />
  );
}
